import { render, staticRenderFns } from "./iframe-loader.vue?vue&type=template&id=32e080d5&scoped=true"
import script from "./iframe-loader.vue?vue&type=script&lang=js"
export * from "./iframe-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e080d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e080d5')) {
      api.createRecord('32e080d5', component.options)
    } else {
      api.reload('32e080d5', component.options)
    }
    module.hot.accept("./iframe-loader.vue?vue&type=template&id=32e080d5&scoped=true", function () {
      api.rerender('32e080d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/iframe-loader.vue"
export default component.exports